import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx"; // chỉ cho danh sách "Giáo viên chủ nhiệm" bên dưới (không liên quan Thi khảo sát)

// (27/10/2026) Đã gỡ hẳn xuất Excel dữ liệu Thi khảo sát (chỉ còn In).
import { getHomeroomTeachers, getThiKhaoSatLopCn } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

// "Giáo viên chủ nhiệm" — mỗi lớp có GVCN: tên GV, SĐT GV, tên lớp, SĐT lớp
// trưởng, SĐT lớp phó. Lớp trưởng/lớp phó lấy từ trường "Chức vụ" của học
// sinh (students/{classId}/{studentId}.classRole — nhập tự do ở trang "Học
// sinh", so khớp không phân biệt hoa/thường và dấu). Không có sẵn khái niệm
// "lớp trưởng/lớp phó" trước trang này, phải thêm field mới cho học sinh.
// 📝 Thi khảo sát — GVCN xem danh sách HS lớp mình kèm Phòng thi, SBD (admin chọn được mọi lớp).
const fmtDob = (d) => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || "")); return m ? `${m[3]}/${m[2]}/${m[1]}` : String(d || ""); };
const REL_LABEL = { cn: "chủ nhiệm", cm: "chuyên môn", "cn+cm": "chủ nhiệm + chuyên môn" };
export const ThiKhaoSatLopCn = ({ schoolId }) => {
  const [q, setQ] = useState({});
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [view, setView] = useState("phong"); // "phong" | "diem" (24/10/2026: tab xem điểm thi)
  useEffect(() => {
    if (!schoolId) return;
    setErr("");
    getThiKhaoSatLopCn(schoolId, q).then(setData).catch((e) => setErr(e.message || "Không tải được."));
  }, [schoolId, q]);
  if (err) return <p style={{ color: "#dc2626" }}>{err}</p>;
  if (!data) return <p>Đang tải...</p>;
  const st = data.students || [];
  const coPhong = st.filter((x) => x.room).length;
  const subs = data.scoreSubjects || [];
  const fmtSc = (v) => (v == null || v === "" ? "" : Number(v).toFixed(2).replace(".", ","));
  const avg = (key) => { const a = st.map((x) => (x.scores || {})[key]).filter((v) => v != null); return a.length ? a.reduce((p, v) => p + Number(v), 0) / a.length : null; };
  const isDiem = view === "diem";
  const printList = () => {
    const esc = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Phòng thi lớp ${esc(data.className)}</title>
<style>@page{size:A4 portrait;margin:12mm}body{font-family:"Times New Roman",serif;font-size:13px}h2{text-align:center;margin:4px 0}.sub{text-align:center;margin:0 0 8px}
table{border-collapse:collapse;width:100%}th,td{border:1px solid #000;padding:4px 6px}th{background:#eee}td.c{text-align:center}tr{page-break-inside:avoid}</style></head><body>
<div style="font-weight:bold">TRƯỜNG TRUNG CẤP KINH TẾ - KỸ THUẬT PHAN CHU TRINH</div>
<h2>${isDiem ? "BẢNG ĐIỂM THI" : "DANH SÁCH PHÒNG THI"} — LỚP ${esc(data.className)}</h2><p class="sub">${esc(data.examName)}${data.monThi && data.monThi.length ? ` — Môn thi: ${esc(data.monThi.join(", "))}` : ""}</p>
${isDiem ? `<table><thead><tr><th>STT</th><th>Họ và tên</th><th>Ngày sinh</th><th>SBD</th><th>Phòng thi</th>${subs.map((m) => `<th>${esc(m.label)}</th>`).join("")}</tr></thead><tbody>
${st.map((x, i) => `<tr><td class="c">${i + 1}</td><td><b>${esc(x.name)}</b></td><td class="c">${esc(fmtDob(x.dob))}</td><td class="c">${esc(x.sbd)}</td><td class="c">${esc(x.room)}</td>${subs.map((m) => `<td class="c"><b>${esc(fmtSc((x.scores || {})[m.key]))}</b></td>`).join("")}</tr>`).join("")}
<tr><td></td><td colspan="4"><b>Điểm trung bình</b></td>${subs.map((m) => `<td class="c"><b>${esc(fmtSc(avg(m.key)))}</b></td>`).join("")}</tr>
</tbody></table>` : `<table><thead><tr><th>STT</th><th>Họ và tên</th><th>Ngày sinh</th><th>SBD</th><th>Phòng thi</th><th>Địa điểm</th></tr></thead><tbody>
${st.map((x, i) => `<tr><td class="c">${i + 1}</td><td><b>${esc(x.name)}</b></td><td class="c">${esc(fmtDob(x.dob))}</td><td class="c">${esc(x.sbd)}</td><td class="c"><b>${esc(x.room)}</b></td><td>${esc(x.location)}</td></tr>`).join("")}
</tbody></table>`}<script>window.onload=function(){setTimeout(function(){window.print()},200)}</script></body></html>`;
    const w = window.open("", "_blank");
    if (!w) { window.alert("Trình duyệt chặn cửa sổ in — cho phép popup rồi bấm lại."); return; }
    w.document.open(); w.document.write(html); w.document.close();
  };
  const sel = { padding: "6px 8px", border: "1px solid #cbd5e1", borderRadius: 6, fontSize: 13 };
  return (
    <div style={{ border: "1px solid #99f6e4", background: "#f0fdfa", borderRadius: 10, padding: 14, marginBottom: 20 }}>
      <h3 style={{ margin: "0 0 8px" }}>📝 Thi khảo sát — xem kết quả</h3>
      {!data.classes || !data.classes.length ? <p style={{ color: "#6b7280", margin: 0 }}>{data.note || "Bạn chưa chủ nhiệm hoặc được phân công dạy lớp nào."}</p> : !data.exams || !data.exams.length ? <p style={{ color: "#6b7280", margin: 0 }}>Chưa có kỳ thi khảo sát nào.</p> : (
        <>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 8 }}>
            <label style={{ fontSize: 13 }}>Kỳ thi: <select style={sel} value={data.examId || ""} onChange={(e) => setQ({ ...q, examId: e.target.value })}>{data.exams.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}</select></label>
            {data.classes.length > 1 ? <label style={{ fontSize: 13 }}>Lớp: <select style={sel} value={data.classId || ""} onChange={(e) => setQ({ ...q, classId: e.target.value })}>{data.classes.map((x) => <option key={x.id} value={x.id}>{x.name}{REL_LABEL[x.relation] ? ` (${REL_LABEL[x.relation]})` : ""}</option>)}</select></label> : <b>Lớp {data.className}{REL_LABEL[(data.classes[0] || {}).relation] ? ` (${REL_LABEL[data.classes[0].relation]})` : ""}</b>}
            <span style={{ flex: 1 }} />
            <button type="button" onClick={printList} disabled={!st.length} style={{ ...btnStyle, margin: 0, background: "#fff", color: "#374151", border: "1px solid #374151" }}>🖨 In</button>
          </div>
          <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
            {[["phong", "🚪 Phòng thi"], ["diem", `📊 Điểm thi${subs.length ? ` (${subs.map((m) => m.label).join(", ")})` : ""}`]].map(([k, label]) => (
              <button key={k} type="button" onClick={() => setView(k)}
                style={{ padding: "6px 12px", borderRadius: 999, fontSize: 13, cursor: "pointer", border: "1px solid #0f766e", background: view === k ? "#0f766e" : "#fff", color: view === k ? "#fff" : "#0f766e", fontWeight: 600 }}>{label}</button>
            ))}
          </div>
          {isDiem ? (!subs.length ? <p style={{ color: "#6b7280" }}>Chưa có điểm thi môn nào của lớp này. Điểm sẽ hiện ở đây khi có.</p> : !st.length ? null : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%", background: "#fff" }}>
                <thead><tr><th style={thStyle}>STT</th><th style={thStyle}>Họ và tên</th><th style={thStyle}>SBD</th><th style={thStyle}>Phòng thi</th>{subs.map((m) => <th key={m.key} style={thStyle}>{m.label}</th>)}</tr></thead>
                <tbody>
                  {st.map((x, i) => (
                    <tr key={x.id}>
                      <td style={{ ...tdStyle, textAlign: "center" }}>{i + 1}</td>
                      <td style={tdNameStyle}>{x.name}</td>
                      <td style={{ ...tdStyle, fontFamily: "monospace" }}>{x.sbd || "—"}</td>
                      <td style={tdStyle}>{x.room || ""}</td>
                      {subs.map((m) => { const v = (x.scores || {})[m.key]; return <td key={m.key} style={{ ...tdStyle, textAlign: "center", fontWeight: 700, color: v == null ? "#9ca3af" : Number(v) < 5 ? "#dc2626" : "#0f766e" }}>{v == null ? "—" : fmtSc(v)}</td>; })}
                    </tr>
                  ))}
                  <tr style={{ background: "#f0fdfa" }}>
                    <td style={tdStyle} /><td style={{ ...tdNameStyle, fontWeight: 700 }} colSpan={3}>Điểm trung bình lớp</td>
                    {subs.map((m) => <td key={m.key} style={{ ...tdStyle, textAlign: "center", fontWeight: 700 }}>{fmtSc(avg(m.key))}</td>)}
                  </tr>
                </tbody>
              </table>
            </div>
          )) : (<>
          <p style={{ fontSize: 13, color: "#374151", margin: "0 0 8px" }}>
            {st.length} học sinh — {coPhong} đã xếp phòng{coPhong < st.length ? `, ${st.length - coPhong} chưa có phòng` : ""}{data.monThi && data.monThi.length ? ` · Môn thi: ${data.monThi.join(", ")}` : ""}
          </p>
          {!st.length ? <p style={{ color: "#6b7280" }}>Lớp chưa có học sinh đang học.</p> : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%", background: "#fff" }}>
                <thead><tr><th style={thStyle}>STT</th><th style={thStyle}>Họ và tên</th><th style={thStyle}>Ngày sinh</th><th style={thStyle}>SBD</th><th style={thStyle}>Phòng thi</th><th style={thStyle}>Địa điểm</th></tr></thead>
                <tbody>
                  {st.map((x, i) => (
                    <tr key={x.id}>
                      <td style={{ ...tdStyle, textAlign: "center" }}>{i + 1}</td>
                      <td style={tdNameStyle}>{x.name}</td>
                      <td style={tdStyle}>{fmtDob(x.dob)}</td>
                      <td style={{ ...tdStyle, fontFamily: "monospace" }}>{x.sbd || "—"}</td>
                      <td style={{ ...tdStyle, fontWeight: 700, color: x.room ? "#0f766e" : "#dc2626" }}>{x.room || "Chưa xếp"}</td>
                      <td style={tdStyle}>{x.location || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          </>)}
        </>
      )}
    </div>
  );
};

const HappySchoolHomeroomTeachers = ({ embedded = false }) => {
  const schoolId = getActiveSchoolId();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!schoolId) return;
    setLoading(true);
    setError("");
    getHomeroomTeachers(schoolId)
      .then(setRows)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [schoolId]);

  const visibleRows = useMemo(() => rows || [], [rows]);

  const exportExcel = () => {
    const header = ["STT", "Giáo viên chủ nhiệm", "SĐT GV", "Lớp chủ nhiệm", "Lớp trưởng (SĐT)", "Lớp phó (SĐT)"];
    const aoa = [header, ...visibleRows.map((r, i) => [i + 1, r.teacherName, r.teacherPhone, r.className, r.lopTruong, r.lopPho])];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws["!cols"] = [{ wch: 5 }, { wch: 28 }, { wch: 14 }, { wch: 14 }, { wch: 34 }, { wch: 34 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "GVCN");
    XLSX.writeFile(wb, "giao_vien_chu_nhiem.xlsx");
  };

  if (!schoolId) {
    return (
      <div style={{ padding: 16 }}>
        Chưa chọn trường. Vào <Link to="/happyschool/schools">Trường của tôi</Link> trước.
      </div>
    );
  }

  return (
    <div style={{ padding: 24, maxWidth: 1000, margin: "0 auto" }}>
      {!embedded && (
        <p style={{ margin: "0 0 6px" }}>
          <Link to="/happyschool" style={{ fontSize: 13, color: "#0ea5a3" }}>← Trang chủ HappySchool</Link>
        </p>
      )}
      <h2 style={{ margin: "0 0 8px 0" }}>Giáo viên chủ nhiệm</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Lớp trưởng/lớp phó lấy theo "Chức vụ" của học sinh — chưa gán thì cột đó để trống.
      </p>

      <button type="button" onClick={exportExcel} disabled={loading || visibleRows.length === 0} style={btnStyle}>
        ⬇ Xuất Excel
      </button>

      {error && <p style={{ color: "#dc2626" }}>{error}</p>}
      {loading ? (
        <p>Đang tải...</p>
      ) : visibleRows.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Chưa lớp nào có Giáo viên chủ nhiệm.</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead>
              <tr>
                <th style={thStyle}>Giáo viên chủ nhiệm</th>
                <th style={thStyle}>SĐT GV</th>
                <th style={thStyle}>Lớp chủ nhiệm</th>
                <th style={thStyle}>Lớp trưởng (SĐT)</th>
                <th style={thStyle}>Lớp phó (SĐT)</th>
              </tr>
            </thead>
            <tbody>
              {visibleRows.map((r) => (
                <tr key={r.className}>
                  <td style={tdNameStyle}>{r.teacherName}</td>
                  <td style={tdStyle}>{r.teacherPhone || "—"}</td>
                  <td style={tdStyle}>{r.className}</td>
                  <td style={tdStyle}>{r.lopTruong || "—"}</td>
                  <td style={tdStyle}>{r.lopPho || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const btnStyle = { margin: "0 0 12px", padding: "8px 14px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13 };
const thStyle = { border: "1px solid #e5e7eb", padding: "6px 10px", background: "#f9fafb", textAlign: "left", whiteSpace: "nowrap" };
const tdStyle = { border: "1px solid #e5e7eb", padding: "6px 10px" };
const tdNameStyle = { ...tdStyle, fontWeight: 600, whiteSpace: "nowrap" };

export default HappySchoolHomeroomTeachers;
